/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
const {isMembershipStatusActivated} = require('od-modules/utils/membership_utils');

const primeAncillariesPage = 'ancillaries/prime';
const paymentPage = 'payment';
const primePostBookingPage = 'primepostbooking';
const passengerDataItem = 'passengersData';
const primePostBookingItem = 'loginEmailPostbooking';

const isPrimeAncillariesPage = () => Odigeo.History.getPageFragment() === primeAncillariesPage;
const isPaymentPage = () => Odigeo.History.getPageNameFromFragment() === paymentPage;
const isPrimePostBookingPage = () => Odigeo.History.getPageNameFromFragment() === primePostBookingPage;

function submitUserRequest(data) {
    Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
        usersmanager.execute('submitUserRequest', data);
    });
}

function isUserDTOMember(userDTO) {
    return !!(userDTO && userDTO.membershipInfoDTO && isMembershipStatusActivated(userDTO.membershipInfoDTO.membershipDTO));
}

function membershipRefreshPage(action) {
    var whiteList = ['home', 'flights', '', '/', 'results', 'details',
        'dpresults_accommodation', 'dpresults_accommodation_details', 'dpresults_flights',
    ];
    const isRenewalAtFirstBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isRenewalAtFirstBooking'));
    if (isRenewalAtFirstBooking) {
        whiteList.push('passengersinfo');
    }
    if (Odigeo._.contains(whiteList, Odigeo.History.getPageNameFromFragment())) {
        window.onbeforeunload = null;
        window.location.reload(true);
    } else {
        notifyWidgets(action);
    }
}

function notifyWidgets(action) {
    Odigeo.trigger('membership:refreshWidgets', action);
    Odigeo.trigger('membership:refreshSubscription', action);
}

function submitUserLogoutRequest(data) {
    return submitUserRequest(Odigeo._.extend({data: '', action: 'logOut'}, data));
}

function getMobilePbJspParams(isMemberBetweenTravellers, page, isPrimeBlocked) {
    return {
        isMemberBetweenTravellers: isMemberBetweenTravellers,
        isPrimeBlocked: isPrimeBlocked,
        comingPage: page,
    };
}

function getMembershipPbItem(membershipSubscriptionModel) {
    return {
        type: 'membershipsubscription',
        data: {
            allprice: membershipSubscriptionModel.allPrice || 0,
            concept: membershipSubscriptionModel.conceptLabel,
            conceptKey: membershipSubscriptionModel.conceptKey,
            oneprice: membershipSubscriptionModel.onePrice || 0,
            quantity: membershipSubscriptionModel.quantity,
        },
    };
}

function openLoginForm(trackingUtils, widgetLoader, e) {
    Odigeo._.result(e, 'stopPropagation');
    trackingUtils.trackEvent('sso_pax_page', 'go_to_login');
    widgetLoader.get('login').execute('openModalLogin');
}

function getEmailFromStorageSession() {
    if (isLoginAfterPax()) {
        const passengersData = Odigeo.Utils.parseJson(Odigeo.Session.get(passengerDataItem));
        return Odigeo._.get(passengersData, 'buyer.mail');
    } else if (isPrimePostBookingPage()) {
        return Odigeo.Session.get(primePostBookingItem);
    }
    return '';
}

function isLoginMatchesBuyer(loginEmail) {
    return isCheckUserMail() ? getEmailFromStorageSession() === loginEmail : true;
}

function isLoginAfterPax() {
    return isPrimeAncillariesPage() || isPaymentPage();
}

function isCheckUserMail() {
    return isLoginAfterPax() || isPrimePostBookingPage();
}

module.exports = {
    submitUserRequest: submitUserRequest,
    membershipRefreshPage: membershipRefreshPage,
    logoutUser: Odigeo._.partial(submitUserLogoutRequest, ''),
    logoutMemberUser: Odigeo._.partial(submitUserLogoutRequest, {isMemberAction: true}),
    isUserDTOMember: isUserDTOMember,
    getMobilePbJspParams: getMobilePbJspParams,
    getMembershipPbItem: getMembershipPbItem,
    openLoginForm: openLoginForm,
    isLoginMatchesBuyer: isLoginMatchesBuyer,
    isCheckUserMail: isCheckUserMail,
    getEmailFromStorageSession: getEmailFromStorageSession,
};
